import React from 'react';
import { Button } from '../../../ui-library/buttons';
import { CartIconWhite } from '../../../ui-library/icons';

function AddToCartButton({ onClick, disabled, ...props }) {
  return (
    <Button
      {...props}
      block
      icon={<CartIconWhite />}
      onClick={onClick}
      disabled={disabled}
    >
      Add to Cart
    </Button>
  );
}

export default AddToCartButton;
